/**
* @Description 文件功能说明：角色弹窗
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <el-dialog :title="dialogTreeItem.title"
               :visible.sync="dialogTreeItem.dialogFormVisible"
               :close-on-click-modal="false"
               custom-class="form-dialog"
               v-dialogDrag
               class="dialog_title"
               @close="handleDialogClose"
    >

        <el-form :model="roleForm" :rules="rules" ref="roleForm" label-width="120px">
            <el-form-item label="角色名称：" prop="name">
                <el-input v-model="roleForm.name"/>
            </el-form-item>
            <el-form-item label="权限设置：">
                <div style="border: 1px solid #034e90;padding: 10px 0;">
                    <div class="tree-group-item">
                        <el-tree
                            ref="resourceTree"
                            :props="defaultProps"
                            :data="resources"
                            node-key="id"
                            :default-expand-all="true"
                            show-checkbox
                            :expand-on-click-node="false"
                            style="margin-top: 10px;"
                            check-strictly
                            @node-click="handleTreeNode"
                            @check="handleCheckBox"
                        >
                        </el-tree>
                    </div>
                </div>
            </el-form-item>
            <el-form-item class="btn-form-item-c">
                <el-button type="primary" size="primary" @click="submitRole()">{{dialogTreeItem.submitButton}}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

</template>

/* JS */
<script>
    import GlobalFun from '@/global/global-function'
    import store from '@/store/index'
    import ApiOam from '@/request/api-oam'

    export default {
        /**
         * @Des 组件名
         * @Auth Zhangbin
         * @Date 16:39 2021/4/30
         */
        name: 'RoleDialog',
        /**
         * @Des 数据定义
         * @Auth Zhangbin
         * @Date 16:39 2021/4/30
         */
        data() {
            return{
                // 资源集合
                resources: [],
                /**
                 * @Des 默认树属性
                 * @Auth Zhangbin
                 * @Date 16:40 2021/4/30
                 */
                defaultProps: {
                    label: 'resourceName',
                    children: 'children'
                },
                /**
                 * @Des 弹出层属性
                 * @Auth Zhangbin
                 * @Date 16:40 2021/4/30
                 */
                dialogTreeItem: {
                    isEdit: false,
                    title: "",
                    dialogFormVisible: false,
                    submitButton: ''
                },
                /**
                 * @Des 角色属性
                 * @Auth Zhangbin
                 * @Date 16:40 2021/4/30
                 */
                roleForm: {
                    id: "",
                    name: "",
                    resources: []
                },
                // 树数据
                treeData: {},
                /**
                 * @Des 规则属性
                 * @Auth Zhangbin
                 * @Date 16:41 2021/4/30
                 */
                rules: {
                    // 判断角色名
                    name: [
                        { required: true, message: '请输入角色名称', trigger: 'blur' },
                        { min: 2, max: 10, message: '长度在2~10个字符', trigger: 'blur' }
                    ]
                }
            }
        },
        /**
         * @Des 方法定义
         * @Auth Zhangbin
         * @Date 16:41 2021/4/30
         */
        methods:{
            /**
             * @Des 打开弹窗
             * @Auth Zhangbin
             * @Date 16:41 2021/4/30
             */
            openRoleDialog(isEdit, data){
                this.treeData = data;
                this.dialogTreeItem.isEdit = isEdit;
                this.dialogTreeItem.title = isEdit?'编辑角色':'新增角色';
                this.dialogTreeItem.dialogFormVisible = true;
                this.dialogTreeItem.submitButton = "保存角色"
                if(data){
                    this.roleForm.id = data.id;
                    this.roleForm.name = data.name;
                }
                this.searchResources();
            },
            /**
             * @Des 关闭弹窗
             * @Auth Zhangbin
             * @Date 16:41 2021/4/30
             */
            handleDialogClose(){
                this.reset()
            },
            /**
             * @Des 查询资源
             * @Auth Zhangbin
             * @Date 16:42 2021/4/30
             */
            searchResources() {
                this.$request.postJsonRequest(ApiOam.Search_All_Resources_Uri,{
                    Role: store.state.userRole,
                    resourceTypes: [1],
                    showType: this.$store.state.showType,// 20, // 1 隧道； 2 通用版
                    required: [0,1]
                }).then(result => {
                    if(result.total > 0){
                        this.resources = GlobalFun.dataToTree(Object.assign([], result.rows), {
                            id: 'resourceId',
                            pid: 'resourceParentId',
                            children: 'children'
                        });
                        if(this.dialogTreeItem.isEdit){
                            this.searchRoleResources();
                        }else{
                            let keys = [];
                            result.rows.forEach((row, index) => {
                                if(row.required == 1){
                                    keys.push(row.resourceId);
                                }
                            })
                            this.$refs.resourceTree.setCheckedKeys(keys);
                        }
                    }
                }).catch(error => {
                    console.error('查询资源异常', ApiOam.Search_All_Resources_Uri, error);
                })
            },
            /**
             * @Des 查询角色资源
             * @Auth Zhangbin
             * @Date 16:42 2021/4/30
             */
            searchRoleResources(){
                this.$request.postJsonRequest(ApiOam.Search_Role_Resources_Uri,{
                    Role: [{ id: this.roleForm.id }],
                    resourceTypes: [1],
                    showType: this.$store.state.showType// 20 // 1 隧道； 2 通用版
                }).then(result => {
                    if(result.total > 0){
                        let keys = [];
                        result.rows.forEach((row, index) => {
                            keys.push(row.resourceId);
                        })
                        this.$refs.resourceTree.setCheckedKeys(keys)
                    }
                }).catch(error => {
                    console.error('查询角色资源异常', ApiOam.Search_Role_Resources_Uri, error);
                })
            },
            /**
             * @Des 重置方法
             * @Auth Zhangbin
             * @Date 16:42 2021/4/30
             */
            reset(){
                // 清除数据
                this.cleanData(this.roleForm);
                // 清除验证
                this.cleanValidate('roleForm')
            },
            /**
             * @Des 提交角色
             * @Auth Zhangbin
             * @Date 16:42 2021/4/30
             */
            submitRole(){
                this.$refs.roleForm.validate(valid => {
                    if(!valid) return false;
                    // 获取所有选中的节点
                    // let checkedNodes = this.$refs.resourceTree.getCheckedNodes();
                    // 获取所有选中的key
                    let checkedKeys = this.$refs.resourceTree.getCheckedKeys();
                    let halfCheckedKeys = this.$refs.resourceTree.getHalfCheckedKeys();
                    checkedKeys = Object.assign([], [...checkedKeys, ...halfCheckedKeys]);// checkedKeys.concat(halfCheckedKeys);
                    if(checkedKeys.length == 0){
                        this.$message({
                            message: '请选择访问权限',
                            type: 'warning',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        return false;
                    }
                    let submitApi = this.dialogTreeItem.isEdit?ApiOam.Update_Role_Uri:ApiOam.Add_Role_Uri;
                    this.$request.postJsonRequest(submitApi,{
                        roleId: this.roleForm.id,
                        roleName: this.roleForm.name,
                        resourceIds: checkedKeys,
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: this.dialogTreeItem.isEdit?'角色修改成功！':'角色创建成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.dialogTreeItem.dialogFormVisible = false;
                            this.$parent.$parent.searchRole()
                            if(this.dialogTreeItem.isEdit){
                                this.treeData.label = this.roleForm.name;
                                this.$parent.$parent.setSelectVal(this.treeData)
                            }
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                    }).catch(error => {
                        console.error('修改角色异常', submitApi, error);
                    })
                })
            },
            /**
             * @Des 清除验证
             * @Auth Zhangbin
             * @Date 16:42 2021/4/30
             */
            cleanValidate(formName){
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
             * @Des 清除数据
             * @Auth Zhangbin
             * @Date 17:01 2021/4/30
             */
            cleanData(form){
                // 延时执行
                this.$nextTick(function () {
                    form.id = '';
                    form.name = '';
                    this.$refs.resourceTree.setCheckedKeys([])
                })
            },
            /**
             * @Des 处理树节点
             * @Auth
             * @Date 2021/6/4
             */
            handleTreeNode(data){
                let currentNode = this.$refs.resourceTree.getNode(data.id);
                // 选中或不选中 当前节点
                this.$refs.resourceTree.setChecked(data.id, !currentNode.checked);
                // 如果当前节点是父节点
                if(data.pid == '0'){
                    // 全选或全不选 子节点
                    if (data.children != null) {
                        for (
                            let j = 0, len = data.children.length;
                            j < len;
                            j++) {
                            this.$refs.resourceTree.setChecked(data.children[j].id, currentNode.checked);
                        }
                    }
                }else{
                    if(currentNode.checked){
                        // 如果选中 子节点， 同时选中父节点
                        this.$refs.resourceTree.setChecked(data.pid, currentNode.checked);
                    }else{
                        // 如果不选中子节点， 判断父节点没有一个字节点被选中，父节点不选中
                        let parentNode = this.$refs.resourceTree.getNode(data.pid);
                        let parentHasCheckedChild = false;
                        for (
                            let i = 0, parentChildLen = parentNode.childNodes.length;
                            i < parentChildLen;
                            i++
                        ) {
                            if (parentNode.childNodes[i].checked) {
                                parentHasCheckedChild = true;
                                break;
                            }
                        }
                        if (!parentHasCheckedChild){
                            this.$refs.resourceTree.setChecked(data.pid, false);
                        }else{
                            this.$refs.resourceTree.setChecked(data.pid, true);
                        }
                    }
                }
            },
            handleCheckBox(data){
                let currentNode = this.$refs.resourceTree.getNode(data.id);
                // 选中或不选中 当前节点
                // console.log(data.id, currentNode.checked)
                // 如果当前节点是父节点
                if(data.pid == '0'){
                    // 全选或全不选 子节点
                    if (data.children != null) {
                        for (
                            let j = 0, len = data.children.length;
                            j < len;
                            j++) {
                            this.$refs.resourceTree.setChecked(data.children[j].id, currentNode.checked);
                        }
                    }
                }else{
                    if(currentNode.checked){
                        // 如果选中 子节点， 同时选中父节点
                        this.$refs.resourceTree.setChecked(data.pid, currentNode.checked);
                    }else{
                        // 如果不选中子节点， 判断父节点没有一个字节点被选中，父节点不选中
                        let parentNode = this.$refs.resourceTree.getNode(data.pid);
                        let parentHasCheckedChild = false;
                        for (
                            let i = 0, parentChildLen = parentNode.childNodes.length;
                            i < parentChildLen;
                            i++
                        ) {
                            if (parentNode.childNodes[i].checked) {
                                parentHasCheckedChild = true;
                                break;
                            }
                        }
                        if (!parentHasCheckedChild){
                            this.$refs.resourceTree.setChecked(data.pid, false);
                        }else{
                            this.$refs.resourceTree.setChecked(data.pid, true);
                        }
                    }
                }
            }
        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
    /deep/ .el-dialog {
    	width: 600px;
    	
        .el-form-item {
	        margin-bottom: 15px;
	    }
	    
	    .el-button {
	    	height: auto;
	    }
	    
	    .tree-group-item {
	    	position: relative;
	    	top: 0;
	    	max-height: calc(90vh - 50px - 2px - 74px - 60px - 122px - 15px - 22px);
	    	
	    	&> div {
	    		margin-top: 0px!important;
	    	}
	    	
	    }
	    
    }
</style>



// WEBPACK FOOTER //
// src/components_pages/Account/RoleDialog.vue